module.exports = __webpack_public_path__ + "static/img/summer_liziPic.0a09cd7d.png";